import React, { useEffect, useState } from 'react';
import styles from './ExcursionsPage.module.css';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Button from '../../components/UI/Button/Button';
import ExcursionSignUpModal from '../../components/ExcursionSignUpModal/ExcursionSignUpModal';
import cn from 'classnames';

export default function ExcursionsPage() {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const ExcursionsImg = require('../../assets/images/ExcursionsImg.png');
  const ExcursionsMobileImg = require('../../assets/images/ExcursionsMobileImg.png');

  useEffect(() => {
    document.body.style.overflow = isModalOpened === true ? 'hidden' : '';
  }, [isModalOpened]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleModal = () => {
    setIsModalOpened((prev) => !prev);
  };

  return (
    <>
      <Helmet>
        <title>Экскурсии | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name='author' content='Восток Строй' />
        <meta name='robots' content='index, follow' />
        <link rel='canonical' href='https://vostokstroy.com/excursions' />

        <meta property="og:title" content="Экскурсии | Восток Строй" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta
          property='og:image'
          content='https://vostokstroy.com/open-graphs/main-opengraph.jpg'
        />
        <meta property='og:url' content='https://vostokstroy.com/excursions' />
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content='Восток Строй' />

        <meta name='twitter:card' content='summary_large_image' />
        <meta name="twitter:title" content="Экскурсии | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta
          name='twitter:image'
          content='https://vostokstroy.com/open-graphs/main-opengraph.jpg'
        />
        <meta name="twitter:url" content="https://vostokstroy.com/excursions" />

        <link rel='icon' type='image/svg+xml' href='/favicons/main-fav-32x32.svg' />
        <link rel='icon' type='image/png' sizes='16x16' href='/favicons/main-fav-16x16.png' />
        <link rel='icon' type='image/png' sizes='32x32' href='/favicons/main-fav-32x32.png' />
        <link
          rel='apple-touch-icon'
          sizes='180x180'
          href='/favicons/main-apple-touch-icon-180x180.png'
        />
        <link rel='icon' type='image/png' sizes='180x180' href='/favicons/main-fav-180x180.png' />
      </Helmet>
      <Header theme='light' />
      <div className={styles.excursions_page}>
        <div className={styles.wrapper}>
          <h2 className={styles.title}>Экскурсии</h2>
          <div className={styles.excursion_content}>
            <p className={cn('text_body_b1', styles.caption)}>
            Во&nbsp;время экскурсии возможно увидеть локацию, узнать о&nbsp;ходе строительства и&nbsp;ознакомиться с&nbsp;будущей инфраструктурой проекта.
            </p>
            <img
              className={styles.excursions_img}
              src={isMobile ? ExcursionsMobileImg : ExcursionsImg}
              alt='Статус'
            />
            <div className={styles.features_wrapper}>
              <div className={styles.features}>
                <div className={cn(styles.feature, styles.feature_one)}>
                  <span className={cn(styles.icon, styles.calendar_icon)}></span>
                  <p className={cn('text_body_b1')}>
                    Выберите удобную для вас дату и&nbsp;время проведения экскурсии
                  </p>
                </div>
                <div className={cn(styles.feature, styles.feature_two)}>
                  <span className={cn(styles.icon, styles.hi_icon)}></span>
                  <p className='text_body_b1'>
                    Встретим, покажем дворы, детские и&nbsp;спортивные площадки, квартиру
                  </p>
                </div>
              </div>
              <Button
                onClick={handleModal}
                colorType='blue'
                paddingType='big'
                roundType='small_rounded'
              >
                Записаться на экскурсию
              </Button>
            </div>
          </div>
        </div>
      </div>
      <ExcursionSignUpModal isActive={isModalOpened} onClose={handleModal} />
      <Footer theme='light' />
    </>
  );
}
